export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="px-6 md:px-12 py-16 md:py-20 border-t border-verlo/10"
    >
      <div className="mx-auto max-w-[1400px] grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img src="/verlo-logo.svg" alt="Verlo" className="h-8 w-auto" />
          <p className="mt-4 text-sm text-verlo/50 max-w-xs">
            The operating system for hospitality. Built in the United Kingdom, for the
            people who run the room.
          </p>
        </div>

        <div className="md:col-span-3 md:col-start-7">
          <p className="text-xs tracking-[0.2em] uppercase text-verlo/40 mb-4">Offices</p>
          <p className="text-sm text-verlo/70 leading-relaxed">
            London
            <br />
            United Kingdom
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs tracking-[0.2em] uppercase text-verlo/40 mb-4">Elsewhere</p>
          <ul className="space-y-2 text-sm text-verlo/70">
            <li>
              <a
                data-testid="footer-social-linkedin"
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-brass transition-colors"
              >
                LinkedIn
              </a>
            </li>
            <li>
              <a
                data-testid="footer-social-instagram"
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-brass transition-colors"
              >
                Instagram
              </a>
            </li>
            <li>
              <a
                data-testid="footer-contact"
                href="mailto:hello@verlohq.com"
                className="hover:text-brass transition-colors"
              >
                hello@verlohq.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] mt-16 pt-8 border-t border-verlo/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="text-xs text-verlo/40">
          © {new Date().getFullYear()} Verlo Ltd. All rights reserved.
        </p>
        <div className="flex gap-6 text-xs text-verlo/40">
          <a href="#" className="hover:text-verlo transition-colors">Privacy</a>
          <a href="#" className="hover:text-verlo transition-colors">Terms</a>
        </div>
      </div>
    </footer>
  );
}
